import React from "react";

const Plane = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path d="M2.48926 17.498H4.48926L6.48926 14.498V10.498L4.48926 7.49805H2.48926L3.48926 12.498L2.48926 17.498Z" fill="#5096FF"/>
    <path d="M7.48926 22.498H11.4893L16.4893 14.498H10.4893L7.48926 22.498Z" fill="#CBDFFF"/>
    <path d="M21.4893 10.5078H4.48926V14.5078H21.4893C22.0197 14.5078 22.5284 14.2971 22.9035 13.922C23.2786 13.5469 23.4893 13.0382 23.4893 12.5078C23.4893 11.9773 23.2786 11.4686 22.9035 11.0936C22.5284 10.7185 22.0197 10.5078 21.4893 10.5078Z" fill="#5096FF"/>
    <path d="M11.4893 2.49805H7.48926L10.4893 10.498H16.4893L11.4893 2.49805Z" fill="#CBDFFF"/>
    </svg>
  );
};

export default Plane;
